import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "survey-item fade-in"
}
const _hoisted_2 = { class: "p-4 is-size-4" }
const _hoisted_3 = { class: "p-4 columns is-multiline" }
const _hoisted_4 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.titleWord), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionWordList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["column is-one-quarter", { 'fade-out': _ctx.isFadeOut }]),
              key: index
            }, [
              _createElementVNode("button", {
                class: "button is-info is-fullwidth",
                onClick: ($event: any) => (_ctx.nextPage(item.tag)),
                disabled: _ctx.isWhiteout
              }, _toDisplayString(item.word), 9, _hoisted_4)
            ], 2))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}